var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"history_wrapper"},[_c('h2',{staticClass:"access_hidden"},[_vm._v("포인트 전환 내역")]),_c('point-info',{attrs:{"a2s":"exchangeHistory"}}),(_vm.userRegion === 'krpc')?[_c('exchange-list')]:[_c('global-exchange-list')],_c('exchange-detail-layer'),_c('exchange-account-layer')],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }